import { render, staticRenderFns } from "./supplier-contract-preview.vue?vue&type=template&id=d975c856&scoped=true"
import script from "./supplier-contract-preview.vue?vue&type=script&lang=js"
export * from "./supplier-contract-preview.vue?vue&type=script&lang=js"
import style0 from "./supplier-contract-preview.vue?vue&type=style&index=0&id=d975c856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d975c856",
  null
  
)

export default component.exports